/*
 * @Author: hzm
 * @Date: 2022-12-16 10:11:00
 * @Description:
 */
import { cloneDeep } from 'lodash';
export function headBreadcrumbMatched(routerMatched) {
  console.log('routerMatched: ', routerMatched);
  return routerMatched
    .filter(item => item.name !== undefined && item?.meta?.title)
    .map(item => {
      const currentMenu = {
        ...item,
        key: item.name,
        props: item.props ? { default: true } : item.props,
      };

      // 是否有子菜单，并递归处理
      if (item.children?.length) {
        currentMenu.children = headBreadcrumbRouteRecordRaw(item.children);
      }
      return currentMenu;
    });
}

export function headBreadcrumbRouteRecordRaw(routerMatched) {
  return routerMatched
    .filter(item => item.name !== undefined)
    .filter(vx => {
      const v = cloneDeep(vx);
      const hasChildren = (v.children?.length ?? 0) > 0;
      const info = hasChildren ? v.children![0] : v;
      return (info.meta?.hidden || false) !== true;
    })
    .map(item => {
      const currentMenu = {
        ...item,
        key: item.name,
        label: item.mate.name,
      };

      // 是否有子菜单，并递归处理
      if (item.children?.length) {
        currentMenu.children = headBreadcrumbRouteRecordRaw(item.children);
      }
      currentMenu.props = item.props ? { default: true } : item.props;
      return currentMenu;
    });
}
